import React, { useState, useEffect } from "react";
import { ReactComponent as IconPlus } from "assets/icons/mas.svg";
import { ReactComponent as IconLess } from "assets/icons/menos.svg";
import { ReactComponent as CloseIcon } from "assets/icons/components/search/close.svg";
import CustomModal from "common/CustomModal";
import { useModalGac } from "hooks/useModalGac";
import { acceptTyc } from "services/tyc.service";
import { getAllTycElite } from "services/tycElite.service";
import {
  filterEliteTycRecords,
  filterActiveTycElite,
} from "utils/tycElite";
import Skeleton from "components/skeleton/Skeleton";
import "styles/terminos/TermsAndConditions.css";
import toast from "react-hot-toast";
import { PROMOCIONES_EXTRAS } from "assets/elite-vacances/promociones";

const INITIAL_DATA = {
  nombre_completo: "",
  numero_contacto: "",
  termino_texto:
    "AUTORIZACIÓN PARA EL TRATAMIENTO DE DATOS PERSONALES. Una vez recibido este BONO DE DESCUENTO autorizo de manera previa, expresa e informada a Elite Vacances S.A.S NIT 901088947-6 RNT  127027; según Ley estatutaria 1581 de 2012 y sus decretos reglamentarios, para que trate mis datos personales conforme a su política de tratamiento de datos, con la finalidad de contactarme, enviar información promocional y ofrecer productos o servicios. Podré ejercer mis derechos de conocer, actualizar, rectificar y suprimir mis datos enviando una solicitud al correo sac@elitevacances.com.",
  fecha_aceptacion: "",
  medio_aceptacion: "Formulario web GAC",
  aceptarTerminos: false,
};

const TermsAndConditions = () => {
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [isOpenModal, openModal, closeModal] = useModalGac(false);
  const [promociones, setPromociones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState(INITIAL_DATA);

  const handleQuestionClick = (question) => {
    if (question === "Términos y condiciones bono de descuento NTB")
      openModal();
    setActiveQuestion(question === activeQuestion ? null : question);
  };

  useEffect(() => {
    const listTyc = async () => {
      try {
        const response = await getAllTycElite();
        const elitePromos = filterActiveTycElite(
          filterEliteTycRecords(
            Array.isArray(response.data) ? response.data : [],
          ),
        );

        if (elitePromos.length > 0) {
          setPromociones(elitePromos);
        } else {
          setPromociones(PROMOCIONES_EXTRAS);
        }
      } catch (error) {
        console.error(error);
        setPromociones(PROMOCIONES_EXTRAS);
      } finally {
        setLoading(false);
      }
    };
    listTyc();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setInfo((prevState) => ({
      ...prevState,
      [name]: value,
      fecha_aceptacion: new Date(),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      acceptTyc(info);
      toast.success("Términos y condiciones aceptados correctamente", {
        duration: 3000,
        position: "top-right",
      });
    } catch (error) {
      console.log(error);
      toast.error("Error al aceptar los términos y condiciones");
    } finally {
      setInfo(INITIAL_DATA);
      closeModal();
    }
  };

  return (
    <section className="containerTyC">
      <h2 className="title__tyc text-center mb-5">
        Sección términos y condiciones promocionales
      </h2>

      <CustomModal isOpen={isOpenModal} closeModal={closeModal}>
        <button className="btn-close-terms" onClick={closeModal}>
          <CloseIcon className="icon-close" />
        </button>

        <section aria-labelledby="titulo" className="container-accept-terms">
          <header>
            <h2 id="titulo">
              AUTORIZACIÓN PARA EL TRATAMIENTO DE DATOS PERSONALES
            </h2>
          </header>
          <article>
            <p>
              Una vez recibido este BONO DE DESCUENTO, autorizo de manera
              previa, expresa e informada a{" "}
              <strong>Elite Vacances S.A.S</strong> NIT 901088947-6 RNT 127027;
              según Ley estatutaria 1581 de 2012 y sus decretos reglamentarios,
              para que trate mis datos personales conforme a su política de
              tratamiento de datos, con la finalidad de contactarme, enviar
              información promocional y ofrecer productos o servicios. Podré
              ejercer mis derechos de conocer, actualizar, rectificar y suprimir
              mis datos enviando una solicitud al correo{" "}
              <a href="mailto:sac@elitevacances.com">sac@elitevacances.com</a>
              Dirección: Calle 93B # 17-25 Oficina 309-310-311 Edificio Centro
              Empresarial PH
            </p>
          </article>
          <form className="form-accept-terms" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="nombre">Nombre Completo:</label>
              <input
                className="input-accept-terms"
                type="text"
                id="nombre_completo"
                name="nombre_completo"
                value={info.nombre_completo}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label htmlFor="numeroContacto">Número de Contacto:</label>
              <input
                type="number"
                id="numero_contacto"
                name="numero_contacto"
                className="input-accept-terms"
                value={info.numero_contacto}
                onChange={handleChange}
                required
                pattern="^\+?[0-9]*$"
                title="Por favor ingresa un número válido"
              />
            </div>

            <div>
              <label htmlFor="aceptarTerminos">
                <input
                  type="checkbox"
                  id="aceptarTerminos"
                  name="aceptarTerminos"
                  checked={info.aceptarTerminos}
                  onChange={handleChange}
                  required
                />
                Acepto los términos y condiciones
              </label>
            </div>

            <button className="btn-accept-terms" type="submit">
              Acepto{" "}
            </button>
          </form>
        </section>
      </CustomModal>

      {loading ? (
        <>
          {Array.from({ length: 5 }).map((_, index) => (
            <div className="acoordionTyc" key={index} style={{ margin: "2em 0" }}>
              <Skeleton type="image" width="100%" height="50px" />
            </div>
          ))}
        </>
      ) : promociones.length > 0 ? (
        <article className="container-__accordion">
          {promociones.map((item) => (
            <div className="acoordionTyc" key={item.apiId || item.id}>
              <div
                className="accordion__headerTyc"
                onClick={() => handleQuestionClick(item.titulo)}
              >
                {item.titulo}
                {activeQuestion === item.titulo ? (
                  <IconLess className="icon-tyc" />
                ) : (
                  <IconPlus className="icon-tyc" />
                )}
              </div>
              <div
                className={`accordion__tyc-content ${
                  activeQuestion === item.titulo && "open"
                }`}
              >
                <span
                  className="accordion__tyc-text"
                  dangerouslySetInnerHTML={{ __html: item.texto }}
                ></span>
              </div>
            </div>
          ))}
        </article>
      ) : (
        <p className="text-center">No hay promociones disponibles.</p>
      )}
    </section>
  );
};

export default TermsAndConditions;
